// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallDevicesPreview__content-ffedbb {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1;
}

.CallDevicesPreview__backgroundContainer-e22bb9 {
  position: relative;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 4;
}

@media (max-width: 1024px) {
  .CallDevicesPreview__content-ffedbb {
    flex-direction: column;
  }
}
@media (max-width: 1024px) {
  .CallDevicesPreview__content-ffedbb {
    flex-direction: column;
    width: 100%;
    max-width: 380px;
    align-self: center;
  }
}
@media (max-width: 768px) {
  .CallDevicesPreview__content-ffedbb {
    justify-content: space-around;
  }
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/CallPreview/CallDevicesPreview/CallDevicesPreview.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,OAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;AACF;;AAEA;EACE;IACE,sBAAA;EACF;AACF;AAEA;EACE;IACE,sBAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;EAAF;AACF;AAGA;EACE;IACE,6BAAA;EADF;AACF","sourcesContent":[".content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  flex: 1;\n}\n\n.backgroundContainer {\n  position: relative;\n  right: 0;\n  top: 0;\n  height: 100%;\n  z-index: 4;\n}\n\n@media (max-width: 1024px) {\n  .content {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 1024px) {\n  .content {\n    flex-direction: column;\n    width: 100%;\n    max-width: 380px;\n    align-self: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .content {\n    justify-content: space-around;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `CallDevicesPreview__content-ffedbb`,
	"backgroundContainer": `CallDevicesPreview__backgroundContainer-e22bb9`
};
module.exports = ___CSS_LOADER_EXPORT___;
